export default "__VITE_ASSET__Dubamt1L__"